<template>
    <div class="page-custom" v-if="customWorkout && customWorkout['treinos-custom'] && customWorkout['treinos-custom'].length">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-9">
                    <div class="page-custom__header">
                        <div class='page-custom__share-icons'>
                            <ShareIcons :text="$root.t('Mantenha%20sua%20rotina%20de%20treinos%20com%20%23TreineEmCasa%20da%20@SmartFitoficial%20Acesse:')" ></ShareIcons>
                        </div>
                        <h4 @click="$root.returnToPreviousPage()" class="page-custom__workout" v-html="activeWorkout.title"></h4>
                        <h1 class="page-title" v-html="`<span>${customWorkout['treinos-custom'][0].title}</span>`"></h1>
                        <div class="page-custom__description" v-html="customWorkout.description"></div>

                        <a href="javascript:void(0);" class="btn btn-outline" @click="$root.returnToPreviousPage()" >{{ $root.t('Voltar') }}</a>
                    </div>
                </div>
                <!-- 
                <div class="col-md-3 mt-5" v-if="customKits.length">
                    <div class="page-custom__kits">
                        <KitCard v-for="kit in customKits" :key="kit.ID" :kit="kit" :category="kit.categories[0].slug"></KitCard>
                    </div>
                </div> -->
            </div>
            <div class="page-custom__content" v-for="c in customWorkout['treinos-custom']" :key="c.ID" v-html="getContentSpan(c.content)"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

// import KitCard from '@/components/KitCard'
import ShareIcons from '@/components/ShareIcons'

export default {
    components : { ShareIcons },
    data () {
        return {
            workoutId : this.$route.params.id,
            customId :  this.$route.params.custom,
            customWorkout : false,
            customKits : [],
        }
    },
    computed : {
        ...mapGetters([
            'activeWorkout',
            'workouts',
            'kits',
            'theme'
        ]),
    },
    watch : {
        workouts () {
            this.setActiveWorkout(this.workoutId)
        },
        activeWorkout() {
            if(this.activeWorkout) {
                this.setActiveCustomWorkout()
            }
        },
        kits () {
            // if( this.Workout.kits ) {
            //     this.customKits = this.custom.kits.map( kit => {
            //         if(!kit.categories.length) {
            //             return false
            //         }
            //         let filtered_kit = {};

            //         for (let i = 0; i < this.kits[kit.categories[0].slug].kits.length; i++ ) {
            //             if ( this.kits[kit.categories[0].slug].kits[i].ID == kit.ID ) {
            //                 filtered_kit = this.kits[kit.categories[0].slug].kits[i];
            //             }
            //         }

            //         return filtered_kit
            //     })
            // }

            return []
        }
    },
    methods : {
        ...mapActions({
            setActiveWorkout : 'setActiveWorkout',
            getKits : 'getKits',
        }),
        setActiveCustomWorkout() {
            this.customWorkout = this.$store.state.workouts.find ( v => v.slug == this.customId )
            this.getKits()
        },
        getContentSpan(str) {
            return str.trim()
            .replace(new RegExp('Fácil', 'g'), '<span class="blue">Fácil</span>')
            .replace(new RegExp('Moderado', 'g'), '<span class="green">Moderado</span>')
            .replace(new RegExp('Máximo', 'g'), '<span class="red">Máximo</span>')
        }
    },
    created () {
        if (!this.activeWorkout) {
            this.setActiveWorkout(this.workoutId)
        } else {
            this.setActiveCustomWorkout()
        }
    },
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/settings/_variables.scss";
    @import "@/assets/scss/settings/_mixins.scss";

    .page-custom {
        /deep/ iframe {
            display: block;
            margin: 0 auto;
            width: 100vw;
            height: calc( 100vw / 1.77);

            @include desktop {
                width: 70vw;
                height: calc( 70vw / 1.77);
            }
        }

        &__header {
            padding: 40px 20px;
            text-align: center;
        }

        &__workout {
            color: $c_primary;
            font-size: 18px;
            font-weight: 300;
            cursor: pointer;
        }

        &__description {
            font-size: 18px;
            opacity: 0.8;
            margin-bottom: 15px;
        }

        &__share-icons {
            padding: 0 0 20px;
        }

        &__content {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            /deep/ {
                .blue { color: #1854a1 !important; }
                .green { color: #226a2f !important; } 
                .red { color: #d30b41 !important; } 

                table { border-collapse: collapse; }

                td { 
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1); 
                    padding: 8px 15px;
                    font-weight: 500;

                    &:nth-child(2) { color: #FFB612; }
                }

                tr:last-child td { border-bottom: none; }

                tbody tr:first-child td {
                    color: gray;
                    font-size: 13px;
                    
                    td { border-bottom: none; }
                }
            }
        }
    }
</style>
